import { Link } from "wouter";
import ServiceCard from "@/components/ServiceCard";
import { services } from "@/data/services";

const Services = () => {
  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="py-20 bg-primary">
        <div className="container mx-auto px-4">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-heading font-bold text-white mb-6">Нашите услуги</h1>
            <p className="text-xl text-white max-w-2xl mx-auto">
              Предлагаме широк спектър от строителни и ремонтни услуги, изпълнени професионално и с внимание към детайла
            </p>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-primary mb-4">Какво предлагаме</h2>
            <div className="w-24 h-1 bg-[#FFC857] mx-auto mb-6"></div>
            <p className="text-gray-700 max-w-2xl mx-auto">
              Нашите специалисти са подготвени да изпълнят всякакви строителни и ремонтни задачи, от малки промени до цялостни преустройства.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service) => (
              <ServiceCard key={service.id} service={service} />
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-20 bg-gray-100">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-primary mb-4">Нашият работен процес</h2>
            <div className="w-24 h-1 bg-[#FFC857] mx-auto mb-6"></div>
            <p className="text-gray-700 max-w-2xl mx-auto">
              Ние спазваме структуриран подход към всеки проект, за да гарантираме високо качество и пълно удовлетворение на клиентите.
            </p>
          </div>
          
          <div className="max-w-4xl mx-auto">
            <div className="flex flex-col md:flex-row gap-8 mb-12">
              <div className="md:w-16 flex flex-col items-center">
                <div className="w-16 h-16 bg-primary rounded-full flex items-center justify-center text-white text-2xl font-bold">1</div>
                <div className="h-full w-1 bg-primary hidden md:block mt-4"></div>
              </div>
              <div className="md:w-[calc(100%-4rem)]">
                <h3 className="text-2xl font-heading font-bold text-primary mb-3">Консултация и оценка</h3>
                <p className="text-gray-700">
                  Първата стъпка е среща с вас, за да разберем вашите нужди, предпочитания и бюджет. Нашите специалисти ще оценят обекта и ще ви предложат най-подходящите решения.
                </p>
              </div>
            </div>
            
            <div className="flex flex-col md:flex-row gap-8 mb-12">
              <div className="md:w-16 flex flex-col items-center">
                <div className="w-16 h-16 bg-primary rounded-full flex items-center justify-center text-white text-2xl font-bold">2</div>
                <div className="h-full w-1 bg-primary hidden md:block mt-4"></div>
              </div>
              <div className="md:w-[calc(100%-4rem)]">
                <h3 className="text-2xl font-heading font-bold text-primary mb-3">Планиране и проектиране</h3>
                <p className="text-gray-700">
                  Ще разработим подробен план и график за изпълнение на проекта. Ако е необходимо, ще включим и изготвяне на дизайн или архитектурни чертежи.
                </p>
              </div>
            </div>
            
            <div className="flex flex-col md:flex-row gap-8 mb-12">
              <div className="md:w-16 flex flex-col items-center">
                <div className="w-16 h-16 bg-primary rounded-full flex items-center justify-center text-white text-2xl font-bold">3</div>
                <div className="h-full w-1 bg-primary hidden md:block mt-4"></div>
              </div>
              <div className="md:w-[calc(100%-4rem)]">
                <h3 className="text-2xl font-heading font-bold text-primary mb-3">Изпълнение</h3>
                <p className="text-gray-700">
                  Нашият екип ще изпълни всички строителни и ремонтни работи според договорените срокове и условия, спазвайки високи стандарти за качество и безопасност.
                </p>
              </div>
            </div>
            
            <div className="flex flex-col md:flex-row gap-8">
              <div className="md:w-16 flex flex-col items-center">
                <div className="w-16 h-16 bg-primary rounded-full flex items-center justify-center text-white text-2xl font-bold">4</div>
              </div>
              <div className="md:w-[calc(100%-4rem)]">
                <h3 className="text-2xl font-heading font-bold text-primary mb-3">Финализиране и гаранция</h3>
                <p className="text-gray-700">
                  След завършване на работите ще направим обстоен преглед заедно с вас, за да се уверим, че всичко отговаря на вашите очаквания. Предоставяме гаранция за всички извършени дейности.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-16 bg-primary text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-heading font-bold mb-6">Нуждаете се от професионална помощ?</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Свържете се с нас за безплатна консултация и оферта за вашия ремонт или строителен проект.
          </p>
          <Link href="/contact">
            <button className="bg-[#D95204] hover:bg-opacity-90 text-white font-bold py-3 px-8 rounded-lg transition duration-300 text-lg">
              Поискайте оферта
            </button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Services;
